


















import { Component, Prop, Vue } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { LoadProjectBasic } from '@/@types/Project';

@Component({
  components: {
    OrganizationIcon
  },
})
export default class ProjectInfo extends Vue {
  private organizationAvatarSize: number = 45;
  private organizationAvatarColor: string = '#fdb44d';

  @Prop({ required: true, default: undefined })
  private project!: LoadProjectBasic | undefined;
}
